import { LinkButton } from "components/buttons";
import e_application_SA_CA_FCCA from "assets/images/e_application_SA_CA_FCCA.svg";
import pds_CA from "assets/pdf/deposits/PRODUCT DISCLOSURE SHEET (PDS) - Commodity Murabahah Current Account-i.pdf";
import pds_SA from "assets/pdf/deposits/PDS CM SA-i_v3_1123 [clean].pdf";
import pds_FC_CA from "assets/pdf/deposits/ENG PDS CM FCY CA-i.pdf";
import { Link, useNavigate } from "react-router-dom";
import { handleOpenPdf } from "utils";

const CM = () => {
  const navigate = useNavigate();
  return (
    <div className="text-grey-color">
      <ul>
        <li>
          <Link onClick={() => handleOpenPdf("https://www.alrajhibank.com.my/assets/compressed/CMCASA4.zip")}>Click here</Link> to download and complete all forms:
        </li>
        <div>1.&emsp;Account Opening / Placement Form</div>
        <div>2.&emsp;Tax Residency Self-Certification Form</div>
      </ul>
      <ul>
        <li>
          Complete the following form to get a mystery gift from preferred
          branch:
        </li>
        <div>3.&emsp;Investor Suitability and Risk Assessment Form</div>
      </ul>
      <ul>
        <li>
          If you are a US Citizen/US Tax Resident/US Indicia, complete as
          follows:
        </li>
        <div>
          4.&emsp;For US Citizen/US Tax Resident, complete FATCA W-9 Form
        </div>
        <div>5.&emsp;For US Indicia, complete FATCA W-8BEN Form</div>
      </ul>
      <ul>
        <li>Please read and understand the following:</li>
        <div>
          6.&emsp;
          <Link to="/tnc">
            Terms and Conditions for Commodity Murabahah Savings/Current
            Account-i/Foreign Currency Current Account-i
          </Link>
        </div>
        <div>
          7.&emsp;
          <Link onClick={() => handleOpenPdf(pds_CA)}>
            Product Disclosure Sheet Commodity Murabahah Current Account-i
          </Link>
        </div>
        <div>
          8.&emsp;
          <Link onClick={() => handleOpenPdf(pds_SA)}>
            Product Disclosure Sheet Commodity Murabahah Savings Account-i
          </Link>
        </div>
        <div>
          9.&emsp;
          <Link onClick={() => handleOpenPdf(pds_FC_CA)}>
            Product Disclosure Sheet Commodity Murabahah Foreign Currency
            Current Account-i
          </Link>
        </div>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You are not required to sign-off all the Forms when you submit
        this application. The signing of these Forms will be performed during
        your visit to the Branch after the account is opened.
      </div>
      <ul>
        <li>
          Scan and attach the following supporting documents with your
          application:
        </li>
      </ul>
      <img
        src={e_application_SA_CA_FCCA}
        width="100%"
        alt="e_application_SA_CA_FCCA"
      />
      <div className="my-3 d-flex gap-3">
        <LinkButton
          text="Product Information - CM Saving Account-i"
          onClick={() =>
            navigate("/personal/deposits/commodity-murabahah-sa-i")
          }
        />
        <LinkButton
          text="Product Information - CM Current Account-i"
          onClick={() =>
            navigate("/personal/deposits/commodity-murabahah-ca-i")
          }
        />
      </div>
      <ul>
        <li>
          Submit all of the above to{" "}
          <a href="mailto:onlineaccountopening@alrajhibank.com.my">
            onlineaccountopening@alrajhibank.com.my
          </a>
        </li>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You will be notified to visit your selected branch to activate
        your account during banking hours.
      </div>
    </div>
  );
};

export default CM;
